export default "__VITE_ASSET__DNyEMTFY__"